import React from 'react';

import Drawing from 'src/assets/boy-and-cat.jpg';
import Typography from 'src/components/shared/Typography';

export default function Home(): React.ReactElement {
  return (
    <div className="relative flex min-h-screen min-h-[100dvh] w-full flex-col items-center justify-center">
      <img
        alt="boy-and-cat"
        className="w-11/12 max-w-[375px] py-[2%] sm:w-1/4 sm:min-w-[375px]"
        src={Drawing}
      />
      <Typography variant="lead">hello, i am albert</Typography>
    </div>
  );
}
